import type { Dispatch, SetStateAction } from 'react'

export const getValueFromDispatch = <T>(
  dispatch: Dispatch<SetStateAction<T>>,
): Promise<T> => {
  return new Promise(resolve => {
    dispatch(v => {
      resolve(v)
      return v
    })
  })
}
